import React from "react";
// reactstrap components
import {
  Button
} from "reactstrap";
import LoginService from "../../services/api/Login";
import { toast } from 'react-toastify';




class MailEventHandler extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      title: ""
    };
  }

  componentDidMount() {

    document.body.classList.add("tenant-page");
    var spans = document.getElementsByClassName('full-page section-image');
    var i;
    for (i = 0; i < spans.length; i++) {
      spans[i].classList.add("df-bg-white");
    }
    let url = window.location.href;  // Geting url as a string format
    let email = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('email');
    let resetToken = new URLSearchParams((url).substring(url.indexOf('&') + 1)).get('resetToken');

    if (email !== null && resetToken !== null && email !== undefined && resetToken !== undefined) { 
      this.resetPassword(email, resetToken);
    }else{
      this.goBackLoginPage();
    }
  }

  resetPassword = (email, token) => {
    if (email !== null && token !== null && email !== undefined && token !== undefined) {
      let currentUrl = window.location.href;
      if (currentUrl.includes("signup/verify")) {
        LoginService.signupResetLink(email, token)
          .then((response) => {
            if (response.status === 'SUCCESS') {
              this.setState({
                message: response.errorMessage,
                title: "Account Verified Successfully"
              })
            } else {
              toast.error(response.errorMessage);
              this.goBackLoginPage();
            }
          }).catch((error) => {
            this.goBackLoginPage();
          })
         } 
      else {
        LoginService.forgotPasswordResetLink(email, token)
          .then((response) => {
            if (response.status === 'SUCCESS') {
              this.setState({
                message: response.errorMessage,
                title: "Password Reset Successfully"
              })
            } else {
              toast.error(response.errorMessage);
              this.goBackLoginPage();
            }
          }).catch((error) => {
            this.goBackLoginPage();
          })
      }
    }
  }

  goBackLoginPage = () => {
    sessionStorage.clear();
    localStorage.clear();
    this.props.history.push('/auth/login-page');
  }

  render() {
    return (
      <div className="content df-bg-white content-handle">
        <div className="card-verify">
          <div className="verify-icon mb-3">
            <i className="checkmark checkmark-style">✓</i>
          </div>
          <h1 className="message-title">{this.state.title}</h1>
          <span className="message-description">{this.state.message}</span>
          <div className="text-center pt-2">
            <Button
              color="primary"
              size="sm"
              onClick={e => this.goBackLoginPage()}
            >
              Ok
            </Button>
          </div>
        </div>

      </div>
    );
  }
}

export default MailEventHandler;